export function resetPassword(send) {
  return (body, ...args) =>
    send(
      {
        path: '/v1/password/reset',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: undefined,
        contentType: 'application/json',
      },
      ...args
    );
}
